import { backgroundOrange, blackOrange, darkOrange, green, orange } from '@/theme/colors'
import styled from 'styled-components'

export const Description = styled.p`
    margin: 0 0 1.25rem 0;
    font-size: 0.8125rem;
    color: #6b7280;
    line-height: 1.5;
`

export const CategoryList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`

export const CategoryRow = styled.button`
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 0.875rem 1.125rem;
    border-radius: 10px;
    background: white;
    border: 1px solid #e5e7eb;
    cursor: pointer;
    text-align: left;
    transition: all 0.15s;
    width: 100%;

    &:hover {
        border-color: ${orange};
        background: #fef9f6;
    }
`

export const CategoryMain = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`

export const CategoryTitle = styled.span`
    font-size: 0.9375rem;
    font-weight: 600;
    color: #262626;
`

export const CategorySubtitle = styled.span<{ $active: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.8125rem;
    color: ${({ $active }) => ($active ? darkOrange : '#9ca3af')};
    font-style: ${({ $active }) => ($active ? 'normal' : 'italic')};
    font-weight: ${({ $active }) => ($active ? 600 : 400)};
`

export const Chevron = styled.span`
    color: #9ca3af;
    font-size: 1.25rem;
    flex-shrink: 0;
`

export const AvatarStack = styled.span`
    display: inline-flex;
    align-items: center;
`

export const StackAvatar = styled.span`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: ${orange};
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 9px;
    border: 2px solid ${backgroundOrange};
    overflow: hidden;
    flex-shrink: 0;

    & + & {
        margin-left: -8px;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const StackOverflow = styled.span`
    margin-left: 0.375rem;
    font-size: 0.8125rem;
    color: ${darkOrange};
    font-weight: 600;
`

export const ButtonGroup = styled.div`
    display: flex;
    gap: 0.5rem;
    width: 100%;
    justify-content: flex-end;
`

export const Button = styled.button<{ $variant?: 'primary' | 'ghost' }>`
    padding: 0.625rem 1.25rem;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    border: 1px solid transparent;

    background: ${({ $variant }) => ($variant === 'primary' ? green : 'transparent')};
    color: ${({ $variant }) => ($variant === 'primary' ? 'white' : blackOrange)};
    border-color: ${({ $variant }) => ($variant === 'primary' ? green : 'transparent')};

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`
